import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="w-full border-t border-border bg-background/80 backdrop-blur-sm">
            <div className="mx-auto max-w-7xl px-6 py-6 text-center text-sm text-muted-foreground">
                <p>
                    Built with care by{' '}
                    <a
                        href="https://yoalfredo.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-medium text-foreground hover:text-primary transition-colors underline underline-offset-4"
                    >
                        Alfredo Diaz
                    </a>{' '}
                    in service of the mission at{' '}
                    <a
                        href="https://pshg.co"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-medium text-foreground hover:text-primary transition-colors underline underline-offset-4"
                    >
                        Polymath Solutions Holding Group
                    </a>
                </p>
                <p className="mt-2 text-xs text-muted-foreground/70">
                    &copy; {year} All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
